/*jshint esversion: 6 */
import { CountUp } from 'countup.js';

const Stats = (function($) {

  const _s = {
    container: '.wp-block-indp-stats',
    item: '.wp-block-indp-stats__item',
    number: '.wp-block-indp-stats__number'
  };

  const _init = function() {
    if ($(_s.container).length === 0) {
      return;
    }

    _animateStats();
  };

  // ===================
  // Animate Stats Block with CountUp
  const _animateStats = function() {
    const statsItems = document.querySelectorAll(_s.item);
    
    statsItems.forEach((item) => {
      const numberElement = item.querySelector(_s.number);
      
      if (numberElement) {
        _setupCountUp(numberElement);
      }
    });
  };

  /**
   * Setup CountUp animation with scroll trigger
   * @param {HTMLElement} element - The stat number element to animate
   */
  const _setupCountUp = function(element) {
    const originalText = element.textContent.trim();
    
    // Parse the stat text to extract number
    const number = parseFloat(originalText.replace(/,/g, ''));
    
    if (isNaN(number)) {
      return;
    }

    // Determine decimal places
    const decimalMatch = originalText.match(/\.(\d+)/);
    const decimals = decimalMatch ? decimalMatch[1].length : 0;

    // CountUp options
    const options = {
      startVal: 0,
      duration: 2,
      useEasing: true,
      useGrouping: true,
      separator: ',',
      decimal: '.',
      decimalPlaces: decimals
    };

    // Create CountUp instance
    const countUp = new CountUp(element, number, options);

    if (!countUp.error) {
      // Use Intersection Observer to trigger animation when in viewport
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !element.dataset.counted) {
            countUp.start();
            element.dataset.counted = 'true';
          }
        });
      }, {
        threshold: 0.5
      });

      observer.observe(element);
    }
  };

  return {
    container: _s.container,
    init: _init
  };

})(jQuery);

export default Stats;
